if (!customElements.get('blog-filter')) {
  class BlogFilter extends HTMLElement {
    constructor() {
      super();

      this.filterDropdown = document.getElementById('blog-filter-dropdown');
      this.filterLinks = this.querySelector('#blog-filter-links');
      this.toggleButton = this.querySelector('.js-blog-filter-toggle');
      this.extraItems = this.filterLinks
        ? Array.from(this.filterLinks.querySelectorAll('.js-blog-filter-extra'))
        : [];

      this.bindEvents();
    }

    bindEvents() {
      if (this.filterDropdown) {
        this.filterDropdown.addEventListener('change', (evt) => {
          const link = this.querySelector(
            `#blog-filter-links a[data-tag="${evt.detail.selectedValue}"]`
          );

          if (link && link.href && link.href !== '#') {
            window.location.href = link.href;
          }
        });
      }

      if (this.toggleButton && this.extraItems.length) {
        this.toggleButton.addEventListener('click', this.handleToggleClick.bind(this));
      }
    }

    handleToggleClick() {
      const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;

      this.extraItems.forEach((item) => {
        item.hidden = !nextExpanded;
      });

      this.toggleButton.setAttribute('aria-expanded', String(nextExpanded));
      this.toggleButton.textContent = nextExpanded
        ? this.toggleButton.dataset.showLessLabel || 'Show less'
        : this.toggleButton.dataset.showMoreLabel || '+ Show more';
    }
  }

  customElements.define('blog-filter', BlogFilter);
}